import React, { useEffect, useState } from "react";
import {
  UserAddOutlined,
  CheckCircleTwoTone,
  WarningTwoTone,
  ExceptionOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";
import { getAuth, sendEmailVerification } from "firebase/auth";
import { Alert } from "antd";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Welcome = () => {
  const { t } = useTranslation("postAuth", {
    keyPrefix: "home",
  });

  const [emailSent, setemailSent] = useState(false);

  const state = useSelector((state) => state.login.user);
  useEffect(() => {
    const verificationEmailSent = localStorage.getItem("verificationEmailSent");
    if (state.emailVerified) {
      setemailSent(false);
      localStorage.removeItem("verificationEmailSent");
    } else if (verificationEmailSent) {
      setemailSent(verificationEmailSent);
    }
  }, [state]);

  const sendVerificationEmail = () => {
    const auth = getAuth();
    localStorage.setItem("verificationEmailSent", true);
    setemailSent(true);
    sendEmailVerification(auth.currentUser);
  };

  return (
    <section className="text-gray-600 body-font bg-white rounded-lg p-2 m-4 mediumShadow">
      <div className="container px-5 py-5 mx-auto flex flex-wrap">
        <div className="flex w-full flex-col-reverse md:flex-row gap-10">
          <div className="lg:w-2/5 md:w-1/2 md:pr-10 md:py-6">
            <div className="flex relative pb-12">
              <div className="h-full w-10 absolute inset-0 flex items-center justify-center">
                <div className="h-full w-1 bg-gray-200 pointer-events-none"></div>
              </div>
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-500 inline-flex items-center justify-center text-white relative z-10">
                <UserAddOutlined className="text-2xl text-secondaryColor" />
              </div>
              <div className="flex-grow pl-4">
                <span className="flex flex-row gap-2 items-center ">
                  <h2 className="font-medium title-font text-sm text-gray-900 mb-1 tracking-wider">
                    {t("STEP 1 create an account")}
                  </h2>
                  <CheckCircleTwoTone twoToneColor="#52c41a" />
                </span>
                <p className="leading-relaxed">
                  Create an account and enrol in a course.
                </p>
              </div>
            </div>
            <div className="flex relative pb-12">
              <div className="h-full w-10 absolute inset-0 flex items-center justify-center">
                <div className="h-full w-1 bg-gray-200 pointer-events-none"></div>
              </div>
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-500 inline-flex items-center justify-center text-white relative z-10">
                <ExceptionOutlined className="text-2xl text-secondaryColor" />
              </div>
              <div className="flex-grow pl-4 gap-2 flex flex-col">
                <span className="flex flex-row gap-2 items-center ">
                  <h2 className="font-medium title-font text-sm text-gray-900 mb-1 tracking-wider">
                    {t("STEP 2 verify your email")}
                  </h2>
                  {state.emailVerified ? (
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  ) : (
                    <WarningTwoTone twoToneColor="#faad14" />
                  )}
                </span>

                <p className="leading-relaxed">
                  Verify your email to get started with your course.
                </p>
                {state.emailVerified ? (
                  <Alert
                    message="Verified"
                    type="success"
                    showIcon
                    className="cursor-pointer shadow-md  rounded-lg "
                  />
                ) : emailSent ? (
                  <Alert
                    message="Verification Email sent, check your inbox"
                    type="info"
                    showIcon
                    className="cursor-pointer shadow-md  rounded-lg "
                  />
                ) : (
                  <motion.span
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.9 }}
                    className="cursor-pointer shadow-md hover:shadow-lg rounded-lg transition-all duration-100"
                    onClick={() => sendVerificationEmail()}
                  >
                    <Alert
                      message={t("emailNotVerifiedMessage")}
                      type="warning"
                      showIcon
                    />
                  </motion.span>
                )}
              </div>
            </div>
            {/* <div className="flex relative pb-12">
              <div className="h-full w-10 absolute inset-0 flex items-center justify-center">
                <div className="h-full w-1 bg-gray-200 pointer-events-none"></div>
              </div>
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-500 inline-flex items-center justify-center text-white relative z-10">
                <DollarOutlined className="text-2xl text-secondaryColor" />
              </div>
              <div className="flex-grow pl-4">
                <span className="flex flex-row gap-2 items-center ">
                  <h2 className="font-medium title-font text-sm text-gray-900 mb-1 tracking-wider">
                    STEP 3 : make Your Payment
                  </h2>
                  <WarningTwoTone twoToneColor="#faad14" />
                </span>
                <p className="leading-relaxed">
                  Coloring book nar whal glossier master cleanse umami. Salvia
                  +1 master cleanse blog taiyaki.
                </p>
              </div>
            </div> */}
            <div className="flex relative">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-500 inline-flex items-center justify-center text-white relative z-10">
                <CheckCircleOutlined className="text-2xl text-secondaryColor" />
              </div>
              <div className="flex-grow pl-4">
                <h2 className="font-medium title-font text-sm text-gray-900 mb-1 tracking-wider">
                  {t("done")}
                </h2>
                <p className="leading-relaxed">
                  Now you can start learning, expect a call from our team soon.
                </p>
              </div>
            </div>
          </div>
          {/* <img
            className="lg:w-3/5 md:w-2/5 object-contain object-center rounded-lg md:mt-0 mt-12"
            src={stopGrammer}
            alt="step"
          /> */}
        </div>
      </div>
    </section>
  );
};

export default Welcome;
